import React from 'react';
import { FileUploaderInputLayoutProps } from '../types';
import { FileDto } from 'nekst-api';
import { ErrorsWrapper, InputLabel, useFormContext } from 'ui-builder';
import { FilePreview } from '../FilePreview';
import { IconButton, IconType } from '../../IconButton';
import { FileUploaderWidget } from '../../FileUploadedWidget';

export default function FileUploaderInputLayoutWeb(
  props: FileUploaderInputLayoutProps
) {
  const formContext = useFormContext();

  return (
    <ErrorsWrapper name={props.name} errors={props.errors}>
      <InputLabel source={props.name} label={props.label} hideLabel={props.hideLabel} />
      <FileUploaderWidget
        onFileUploaded={async (file: FileDto) => {
          formContext.onChangeCallback!({
            [props.name]: file.id,
            [props.fileDataSource]: file,
          });
        }}
        onUploaderStart={() => {
          formContext.__setErrors!({});
          formContext.setDisabled!(true);
        }}
        onValidationErrors={(errors) => {
          formContext.__setErrors!(errors);
        }}
        onFinished={() => {
          formContext.setDisabled?.(false);
        }}
        name={props.name}
        fileType={props.fileType}
        asAdmin={props.asAdmin}
      />
      {props.file && (
        <div style={{ marginTop: '1rem' }}>
          <FilePreview data={props.file} />
          <IconButton
            onClick={() => {
              formContext.onChangeCallback!({
                [props.name]: undefined,
                [props.fileDataSource]: undefined,
              });
            }}
            type={IconType.TRASH_CAN}
            title="Delete"
          />
        </div>
      )}
    </ErrorsWrapper>
  );
}
